<template>
    <ListingModel category="FILTER" />
</template>
<script>
import ListingModel from "@/views/Notification/Components/ListingModel.vue";

export default {
    name: "NotificationPage",
    components: {ListingModel},
}
</script>

<style scoped>

</style>